import { reboot, turnOff } from 'api/api_service';
import ConfirmModal from 'components/confirm_modal';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import strings from '../../strings/strings.json'
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";

export default function Header() {
    const history = useHistory()
    const [title, setTitle] = useState<string>()
    const [confirmModal, setOpenConfirmModal] = useState(false)
    const dispatch = useDispatch()

    const openModalHandler = (title: string) => {
        setTitle(title)
        setOpenConfirmModal(true)
    }

    const confirmHandler = (data: any) => {
        if (data === strings.public_turnOff) {
            turnOff()
                .then(res => {
                    if (res.status === 200 && res.data.success) {
                        setOpenConfirmModal(false)
                        dispatch(showSnackbar({ "open": true, severity: "success", msg: strings.public_operationDone }));
                    } else {
                        dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.public_error }));
                    }
                })
                .catch(err => {
                    if (err.response.data.error_code === 96) {
                      dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.demo_error }));
                    }  else {
                       dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.public_error }));
                   }              	
               })
        } else {
            reboot()
                .then(res => {
                    if (res.status === 200 && res.data.success) {
                        setOpenConfirmModal(false)
                        dispatch(showSnackbar({ "open": true, severity: "success", msg: strings.public_operationDone }));
                    } else {
                        dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.public_error }));
                    }
                })
                .catch(err => {
                     if (err.response.data.error_code === 96) {
                       dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.demo_error }));
                     }  else {
                        dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.public_error }));
                    }              	
                })
        }
    }

    return (
        <header dir='rtl' className='flex w-full justify-around bg-gray-100 py-5 px-10'>
            <div className='w-full'>
                <img src={require('../../assets/icons/main_logo.svg').default} alt="Icon" />
            </div>
            <div className='w-full flex justify-end'>
                <div className='flex w-64 justify-around '>
                    <div style={{ cursor: 'pointer' }} className='w-10 h-10 flex justify-center items-center border-black rounded-full border' onClick={() => history.push('/')}><img className='h-5 w-5' src={require('../../assets/icons/home.svg').default} alt="Icon" /></div>
                    <div style={{ cursor: 'pointer' }} className='w-10 h-10 flex justify-center items-center border-black rounded-full border' onClick={() => openModalHandler(strings.public_turnOff)}><img className='h-5 w-5' src={require('../../assets/icons/power.svg').default} alt="Icon" /></div>
                    <div style={{ cursor: 'pointer' }} className='w-10 h-10 flex justify-center items-center border-black rounded-full border' onClick={() => openModalHandler(strings.public_reboot)}><img className='h-5 w-5' src={require('../../assets/icons/reboot.svg').default} alt="Icon" /></div>
                    <div style={{ cursor: 'pointer' }} className='w-10 h-10 flex justify-center items-center border-black rounded-full border' onClick={() => history.push('/settings')}><img className='h-5 w-5' src={require('../../assets/icons/cog.svg').default} alt="Icon" /></div>
                </div>
            </div>
            <ConfirmModal
                data={title}
                openModal={confirmModal}
                onCloseModal={() => setOpenConfirmModal(false)}
                confirmClicked={(data) => confirmHandler(data)}
            />
        </header>
    );
}
